import gql from "graphql-tag";

const ListCategoriesSelectedUser = gql`
  query listCategoriesSelectedUser(
    $idUserRecipient: String!
    $idWorkflow: String!
    $isArchive: Boolean
  ) {
    getEvaluationCardAdmin(
      idUserRecipient: $idUserRecipient
      idWorkflow: $idWorkflow
      isArchive: $isArchive
    ) {
      idWorkflow
      idStructure
      idUserRecipient
      valors {
        description
        id
        idMacroArea
        nameMacroArea
        numKeepGoing
        numThinkAbout
        title: sort2
        labels {
          value
          description
        }
        finalScore
        ratingAverage
      }
      skills {
        description
        id
        idMacroSkill
        nameMacroSkill
        numKeepGoing
        numThinkAbout
        title: sort2
        labels {
          value
          description
        }
        finalScore
        ratingAverage
      }
      goals {
        description
        id
        numKeepGoing
        numThinkAbout
        finalScore
        title: sort2
        labels {
          value
          description
        }
        ratingAverage
      }
      macroarea {
        id
        finalScore
      }
      macroskill {
        id
        finalScore
      }
      synthesis {
        mediaRatingFeedback
        autovalutationScore
        finalScore
        managerNote
        collaboratorNote
        bossQuestions {
          question
          answer
        }
        questions {
          question
          answer
        }
      }
      noCard
      autovalutationStatus
      collaboratorNotification
      version
    }
  }
`;

export default ListCategoriesSelectedUser;
